/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_themeBase/_helpers";



export const GroupSettingActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    {
        openAttendenceSettingPage, accessAttendence,
        openCullinanSettingPage, accessCullinan,
        openDormSettingPage, accessDorm,
        openSportSettingPage, accessSport,
        openBankAccountAccessPage, accessBankAccountAccess,
    }
) => (
    <div className="float-right border-0 " style={{ maxHeight: "45px" }}>
        {accessBankAccountAccess &&
            <td className="border-0">
                <OverlayTrigger
                    overlay={<Tooltip id="objects-edit-tooltip">حساب های بانکی مجاز</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={() => openBankAccountAccessPage(row.id)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")}
                            />
                        </span>
                    </a>
                </OverlayTrigger>
            </td>
        }

        {accessAttendence &&
            <td className="border-0">
                <OverlayTrigger
                    overlay={<Tooltip id="objects-edit-tooltip">تنظیمات حضور غیاب</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={() => openAttendenceSettingPage(row.id)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}
                            />
                        </span>
                    </a>
                </OverlayTrigger>
            </td>}


        {accessCullinan &&
            <td className="border-0">
                <OverlayTrigger
                    overlay={<Tooltip id="objects-edit-tooltip">تنظیمات تغذیه</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={() => openCullinanSettingPage(row.id)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Cooking/Chef.svg")}
                            />
                        </span>
                    </a>
                </OverlayTrigger>
            </td>
        }



        {accessDorm &&
            <td className="border-0">
                <OverlayTrigger
                    overlay={<Tooltip id="objects-edit-tooltip">تنظیمات خوابگاهی</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={() => openDormSettingPage(row.id)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Home/Bed.svg")}
                            />
                        </span>
                    </a>
                </OverlayTrigger>
            </td>
        }


        {accessSport &&
            <td className="border-0" >
                <OverlayTrigger
                    overlay={<Tooltip id="objects-edit-tooltip">تنظیمات ورزشی</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={() => openSportSettingPage(row.id)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Clothes/T-Shirt.svg")}
                            />
                        </span>
                    </a>
                </OverlayTrigger>
            </td>
        }

    </div>
);
